import type { ReactNode } from 'react';

import type { SortOrder } from './types';

interface SortingHeaderProps {
    isSorted?: boolean;
    sortOrder?: SortOrder;
    onClick: () => void;
    hidden?: boolean;
    className?: string;
    children: ReactNode;
}

const SortingHeader = ({
    isSorted = false,
    sortOrder = 'asc',
    onClick,
    hidden = false,
    className,
    children,
}: SortingHeaderProps) => {
    if (hidden) {
        return null;
    }

    const arrowClass = sortOrder === 'asc' ? 'icon-arrow-up' : 'icon-arrow-down';
    const headerClassName = ['SortingHeader user-select-none cursor-pointer', isSorted ? 'sorted' : '', className ?? '']
        .filter(Boolean)
        .join(' ');

    return (
        <th className={headerClassName} onClick={onClick} data-testid={isSorted ? 'sorted-header' : undefined}>
            <span>{children}</span>
            {isSorted && (
                <span className={`uikit-icon ${arrowClass} sortIcon margin-left-5`} data-testid={`sort-${sortOrder}`} />
            )}
        </th>
    );
};

export default SortingHeader;
